import type { CSSProperties, ReactNode } from 'react';
import SectionHeading from '../components/SectionHeading';
import type { Colors } from '../theme';

interface Props {
  colors: Colors;
  mobile: boolean;
  sectionStyle: CSSProperties;
}

export default function IntroductionSection({ colors, mobile, sectionStyle }: Props) {
  // The introduction renders like previewed markdown; hovering (or tapping) a line
  // reveals its raw source by showing the syntax markers (see .md-line in index.css).
  const syntax: CSSProperties = { color: colors.accent, opacity: 0.7 };
  const strong: CSSProperties = { color: colors.fg, fontWeight: 700 };
  const em: CSSProperties = { color: colors.fg, fontStyle: "italic" };

  const Syn = ({ children }: { children: ReactNode }) => <span className="md-syn" style={syntax}>{children}</span>;
  const B = ({ children }: { children: ReactNode }) => (
    <><Syn>**</Syn><span style={strong}>{children}</span><Syn>**</Syn></>
  );

  const bodyStyle: CSSProperties = {
    margin: 0,
    fontSize: 14,
    lineHeight: 1.7,
    letterSpacing: "-0.01em",
    color: colors.muted,
  };

  return (
    <section id="introduction" style={sectionStyle}>
      <SectionHeading colors={colors} mobile={mobile}>
        [spandan@portfolio ~]$ cat introduction.md
      </SectionHeading>

      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: 28,
        maxWidth: 720,
        width: "100%",
        alignSelf: mobile ? "center" : undefined,
        textAlign: mobile ? "center" : undefined,
      }}>
        <p className="md-line" tabIndex={0} style={{
          margin: 0,
          fontSize: mobile ? 19 : 23,
          lineHeight: 1.55,
          letterSpacing: "-0.01em",
          fontWeight: 500,
        }}>
          <Syn># </Syn>theres nothing more interesting than technology!
        </p>

        <p className="md-line" tabIndex={0} style={bodyStyle}>
          hey im <B>Spandan Shrestha</B>, a computer science student at <B>UCLL</B> specialising in <B>Cyber Security</B>. I love tech... its the coolest thing ever. always wanted to see whats new in the world.
        </p>

        <p className="md-line md-quote" tabIndex={0} style={{
          margin: 0,
          fontSize: 14,
          lineHeight: 1.7,
          color: colors.muted,
          ['--md-hair' as string]: colors.hair,
        } as CSSProperties}>
          <Syn>&gt; </Syn>Always learning. Always building.
        </p>

        <p className="md-line" tabIndex={0} style={bodyStyle}>
          the goal is to become more than just "<Syn>__</Syn><span style={em}>a tech guy</span><Syn>__</Syn>" and to become "<B>THE</B> tech guy" people could rely on. thats why is i keep up with new things and try to make it <B>fun</B> while i can
        </p>
      </div>
    </section>
  );
}
